import React from 'react';

export const CommentContext = React.createContext();
export const ChatContext = React.createContext();
